import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="mt-5 container mx-auto text-center">
      <h1 style={{ color: "grey", fontSize: "5rem" }}>
        {" "}
        Oops :(
        <br /> 404 - Page Not Found!
      </h1>
      <h5 className="mt-5 text-danger">
        The page you are looking for might have been removed or had its name
        changed or is temporarily unavailable!
      </h5>
      <Link className="btn btn-outline-success mt-3" to="/">
        Go To Home
      </Link>
    </div>
  );
};

export default NotFound;
